import { Variant } from '~/@types/product'
import { akairosApi } from '~/lib/constants'

export async function getSaucerImgUrl(customizerSaucer: Variant) {
  if (!customizerSaucer) return null

  const sku = customizerSaucer.sku
  let sub = sku.replace(/-/g, '/')
  sub = sub.slice(0, sub.lastIndexOf('/'))

  if (!sub || !sku) return null
  const url = `https://${akairosApi.MAIN}/storage/assets/img/products/${sub}/${sku}.png`

  try {
    const response = await fetch(url)
    if (response?.status !== 200) {
      throw new Error()
    } else {
      return { url }
    }
  } catch {
    return null
  }
}
